var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-money","titulo":"RENDIMENTOS ANUAIS (DIRFs)"},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'Dirfs' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }